<template>
    <div class="or-admin-news">
        <p class="add nesting-main hover-pointer hover-yellow" @click="add">+ Добавить новость</p>
        <or-admin-news-card class="card nesting-main" :options="item" @remove="remove(i)" @up="up(i)" @down="down(i)" v-for="(item, i) in options" :key="item.id" @unsaved="unsaved"/>
    </div>
</template>

<script>
import {mapActions} from 'vuex'
import orAdminNewsCard from '../global/or-admin-news-card.vue'
export default {
    components: {orAdminNewsCard},
    props: {
        options: Object,
        deleted: Array,
    },
    data() {
        return {
            news: [],
        }
    },
    methods: {
        ...mapActions({addUnsavedPage: 'addUnsavedPage'}),
        unsaved() {
            this.addUnsavedPage({page: 'news'})
        },
        add() {
            this.options.unshift({
                id: this.get_id(this.options),
                title: {
                    title: 'Заголовок',
                    value: 'Безымянная новость, но очень интересная',
                },
                text: {
                    title: 'Текст новости',
                    value: 'Интересный текст новости',
                },
                date: {
                    title: 'Дата публикации',
                    value: this.get_date(),
                }
            })
            this.addUnsavedPage({page: 'news'})
        },
        remove(index) {
            const deleted = this.options.splice(index, 1)[0];
            this.deleted.push(deleted.id);
            this.addUnsavedPage({page: 'news'})
        },
        up(index) {
            if (index === 0) return;
            const item = this.options.splice(index, 1)[0];
            this.options.splice(index - 1, 0, item);
            this.addUnsavedPage({page: 'news'})
        },
        down(index) {
            if (index === this.options.length - 1) return
            const item = this.options.splice(index, 1)[0];
            this.options.splice(index + 1, 0, item);
            this.addUnsavedPage({page: 'news'})
        },
        get_id(options) {
            let id = 0;
            options.map(el=>{
                if (el.id > id) {
                    id = el.id
                }
            })
            return id + 1;
        },
        get_date(){
            const current_datetime = new Date()
            let formatted_date = current_datetime.getFullYear() + "-" + (current_datetime.getMonth() + 1) + "-" + current_datetime.getDate() + " " + current_datetime.getHours() + ":" + current_datetime.getMinutes();
            return formatted_date;
        }
    }
    
}
</script>

<style scoped>
    .card {
        margin-bottom: 50px;
    }
    .add {
        font-size: 14px;
        line-height: 16px;
        margin-top: 50px;
        text-align: left;
        margin-bottom: 50px;
        color: #3dc986;
    }
</style>